import { ReactNode } from "react";

export const TablaCategorias = ({ children }: { children: ReactNode }) => {
  return (
    <div className="table-responsive">
      <table className="table table-striped table-bordered align-middle">
        <thead>
          <tr>
            <th style={{ width: "3%" }} scope="col">
              Nombre
            </th>
            <th style={{ width: "2%" }} scope="col">
              Acciones
            </th>
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
};
